/**
 * Волна D (docs/MIGRATION_ROUTER.md §5).
 * Было: <PrivateRoute path='/order/sbp/:id'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../CacheDataRoute';
import OrderSBP from '@routes/OrderSBP';

export const Route = createFileRoute('/order/sbp/$id')({
  staticData: { layout: { isOnlyMainHeader: true, withoutFooter: true } },
  component: () => (
    <CacheDataRoute
      component={OrderSBP}
      path='/order/sbp/:id'
    />
  )
});
